import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import ConfirmCopyModal from "components/modals/ConfirmCopyModal";

interface Props {
  production: server.dto.Tour
  isOpen: boolean
  onClose: () => void
}

const ConfirmCopyProductionModal = (props: Props) => {
  const apiCall = async () => {
    const response = await window.CoreApi.Production.Copy(props.production.productionId);
    return response.data;
  };

  return <ConfirmCopyModal
    isOpen={props.isOpen}
    apiCall={apiCall}
    onClose={props.onClose}
    onSuccess={(itemId) => window.location.href = routes.production_Detail(itemId).absolute}
  />;
};

export default ConfirmCopyProductionModal;